import React from 'react';

import Icon from 'Components/Globals/Elements/Icon/loadable';
import { STATUS_TRANSLATOR } from 'Constants';
import useContent from 'Hooks/useContent';
import {
	convertRialToToman,
	composeClassNames,
	convertGregorianToJalali,
} from 'Helpers';

import styles from './styles.module.scss';
import strings from './strings';

const ItemModal = ({
	amount,
	traceId,
	status,
	confirmedAt,
	payedAt,
	settlementId,
	isSettlement,
}) => {
	const { formatMessage } = useContent();

	const INFORMATION = [
		{
			id: 1,
			title: formatMessage(strings.status),
			value: status,
		},
		{
			id: 2,
			title: formatMessage(strings.confirmedAt),
			value: convertGregorianToJalali(confirmedAt),
		},
		{
			id: 3,
			title: formatMessage(strings.traceId),
			value: traceId,
		},
		{
			id: 4,
			title: formatMessage(strings.payedAt),
			value: convertGregorianToJalali(payedAt),
		},
		{
			id: 5,
			title: formatMessage(strings.settlementId),
			value: settlementId,
		},
		{
			id: 6,
			title: formatMessage(strings.amount),
			value: amount && convertRialToToman(amount).replaceAll(',', '،'),
			icon: 'toman',
		},
	];
	const titleStyle = (id) => {
		return composeClassNames([
			'sm',
			id === 6 ? 'txt-black bold' : 'txt-text-dark',
		]);
	};
	const valueStyle = (id, value) => {
		if (value === 'pend') {
			return composeClassNames(['sm', styles.status_pending]);
		} else if (value === 'done') {
			return composeClassNames(['sm', styles.status_success]);
		} else {
			return composeClassNames([
				'sm',
				styles.value,
				id === 6 ? 'txt-black bold' : 'txt-text-dark',
			]);
		}
	};
	return (
		<>
			<div>
				{INFORMATION.filter(
					(information) =>
						isSettlement || (information.id !== 4 && information.id !== 5)
				).map((information) => (
					<div
						className={styles.wrapper}
						key={information.id}
					>
						<p className={titleStyle(information.id)}>{information.title}</p>
						<p className={valueStyle(information.id, information.value)}>
							{information.id === 1
								? STATUS_TRANSLATOR[information?.value]
								: information?.value}
							{information.icon && <Icon name={information.icon} />}
						</p>
					</div>
				))}
			</div>
		</>
	);
};

export default ItemModal;
